import React, { useEffect,useState } from 'react';
import { Box, Typography } from '@mui/material';
import { getViewEgiftData } from '../../redux/action/eGiftCards';
import { connect,useSelector } from "react-redux";
import CardView from '../../components/Custom/ViewCardDetail/CardView';
import { useLocation } from 'react-router-dom';

const ViewEgiftCards = ({getViewEgiftData}) => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [data, setData] = useState({})
    useEffect(() => {
    window.scrollTo(0, 0);
    let data = { egift_id:location.state };
    getViewEgiftData(data).then((res)=>{
      setLoading(false)
      setData(res.data.data)
    });
  }, []);
  return (
    <Box sx={{
      display: "flex",
      flexDirection: "row",

    }}>
      <CardView
       load={  loading  }
       image={data.file_path}
       title={data?.title}
      />
      {/* <img 
       src={require("../../assets/egift(1).png")}
       style={{width:"215px",height:"199px"}}
       />

       <Box sx={{
        display: "flex",
        flexDirection: "column",
        ml: 4,pt:2,
       }}>
        <Typography sx={{
          color: "#3D2E57"
        }}>
          Title
        </Typography>
        <Typography>
          $ 6.00
        </Typography>
        <Typography>
          Description
        </Typography>
        <Typography sx={{
          fontSize: "18px",
          width: "85%",
        }}>
        There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. 
        </Typography>
       </Box> */}
    </Box>
  )
}

function mapDispatchToProps(dispatch) {
  return {
    getViewEgiftData: (data) => dispatch(getViewEgiftData(data)),
  };
}
export default connect(null, mapDispatchToProps)(ViewEgiftCards);